export default __webpack_public_path__ + "static/media/47_3_2.14f567b0.png";